import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, Grid } from '@nu-art/thunderstorm-frontend/index';
import { allOperators, booleanExpressions } from './EditorOperators.js';
export class Component_CalculatorButtons extends ComponentSync {
    // __contextChange(context?: string, firstTime?: boolean) {
    // 	if (!this.props.freeForm)
    // 		this.setState({expressionType: context, firstLoad: firstTime!});
    // }
    deriveStateFromProps(nextProps, state) {
        state = this.state ?? {};
        state.firstLoad = !nextProps.freeForm;
        return state;
    }
    updateValue = (button) => {
        const position = this.props.editor.getPosition();
        if (position) {
            const model = this.props.editor.getModel();
            if (model) {
                const offset = model.getOffsetAt(position);
                const fullText = model.getValue();
                const newText = fullText.slice(0, offset) + button.operand + fullText.slice(offset);
                model.setValue(newText);
                this.props.editor.focus();
                const newPosition = model.getPositionAt(offset + button.operand.length);
                // @ts-ignore
                newPosition.column = button.cursorLocationLogic(newPosition.column);
                this.props.editor.setPosition(newPosition);
            }
        }
    };
    renderButtons = () => {
        if (this.state.firstLoad)
            return '';
        if (!this.state.expressionType)
            return allOperators.map(button => button.element(() => {
                this.updateValue(button);
            }));
        return booleanExpressions.map(button => button.element(() => {
            this.updateValue(button);
        }));
    };
    render() {
        return _jsx(Grid, { className: 'buttons', style: { width: this.props.width }, children: this.renderButtons() });
    }
}
//# sourceMappingURL=Component_CalculatorButtons.js.map